var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomersMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Color Copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.219,0.375227792 L5,4.39922779 L1.781,0.375227792 C1.515,0.0432277921 1.068,-0.0837722079 0.669,0.0562277921 C0.269,0.197227792 0,0.575227792 0,1.00022779 L0,16.0002278 C0,17.1032278 0.897,18.0002278 2,18.0002278 L16,18.0002278 C17.103,18.0002278 18,17.1032278 18,16.0002278 L18,1.00022779 C18,0.575227792 17.731,0.197227792 17.331,0.0562277921 C16.931,-0.0817722079 16.485,0.0442277921 16.219,0.375227792 L13,4.39922779 L9.781,0.375227792 C9.4,-0.0987722079 8.6,-0.0987722079 8.219,0.375227792 Z M2,16.0002278 L2,14.0002278 L16.001,14.0002278 L16.001,16.0002278 L2,16.0002278 Z M12.219,6.62522779 C12.6,7.10022779 13.401,7.10022779 13.782,6.62522779 L16,3.85122779 L16.001,12.0002278 L2,12.0002278 L2,3.85122779 L4.219,6.62522779 C4.6,7.10022779 5.401,7.10022779 5.782,6.62522779 L9,2.60122779 L12.219,6.62522779 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-32.000000, -350.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Menu"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(17.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 256.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Color-Copy-7"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#8592A3",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.1,
    fill: "#000000",
    xlinkHref: "#path-1"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersMenu);
export default __webpack_public_path__ + "static/media/Customers-menu.fe9398e66fb93e681cf762e2f7f15b99.svg";
export { ForwardRef as ReactComponent };